import React, { Component } from 'react';
import styled from 'styled-components';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import ListHeader from '../../../../components/List/Header';
import ListRow from '../../../../components/List/Row';
import Select from '../../../../components/Select';
import { I18n } from 'react-redux-i18n';
import Pills from '../../../../components/Pills';
import get from 'lodash/get';

const WineCompetitorsContainer = styled.div`
  .wineCompetitorsListContainer {
    min-height: 450px;
    max-height: 450px;
    overflow-y: auto;
  }

  .rightHeaderContainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    z-index: 2;
  }

  .pillsContainer {
    margin-right: auto;
    margin-left: 20px;
  }
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  :not(:last-child) {
    border-bottom: 1px solid #e8e9eb;
  }

  .wineItem {
    margin-left: 20px;
  }

  .wineNameContainer {
    background-color: white;
    width: 33%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    height: ${(props) => props.length * 50}px;
  }

  .brandNameContainer {
    background-color: white;
    width: 33%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 10px;
    padding-bottom: 10px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    height: ${(props) => props.length * 50}px;
  }

  .brandItem {
    margin-left: 20px;
  }

  .brandWineContainer {
    margin-top: 10px;
    white-space: normal;
    max-height: 100%;
    overflow-y: auto;
    margin-left: 20px;
  }

  .brandWineItem {
    opacity: 0.5;
    line-height: 1.5;
  }

  .rowsContainer {
    display: flex;
    flex-direction: column;
    width: 67%;
    font-size: 14px;
  }

  .rowsContainer > li {
    height: 50px;
    width: 100%;
  }

  .rowsContainerBrand {
    display: flex;
    flex-direction: column;
    width: 67%;
    font-size: 14px;
  }

  .rowsContainerBrand > li {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: initial;
    padding: 20px 0;
  }

  .competitorWineItem {
    opacity: 0.5;
    line-height: 1.8;
  }

  .competitorWineContainer {
    margin-top: 10px;
    white-space: normal;
    max-height: 60px;
    overflow-y: auto;
    margin-left: 20px;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .competitorItem {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    margin-left: 20px;
    font-size: 12px;
  }
`;

class WineCompetitors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePill: 'wine',
      selectedService: {
        label: I18n.t('restaurants&caves.subTitle.wine'),
        value: I18n.t('restaurants&caves.subTitle.wine')
      }
    };
  }

  componentDidMount() {
    if (this.props.isBranded) {
      this.setState({ activePill: 'brands' });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isBranded !== this.props.isBranded && this.props.isBranded) {
      this.setState({ activePill: 'brands' });
    }
  }

  formatOptions(data) {
    let formattedOptions = [...data].filter(
      (item) => item.service.specific_wines === true
    );
    let uniqueServices = [
      ...new Set(formattedOptions.map((item) => item.service.name))
    ].map((name) => ({
      label:
        name === 'default'
          ? I18n.t('admin.benchmarkColumns.defaultService')
          : name,
      value: name
    }));
    return uniqueServices;
  }

  formatBrandOptions() {
    const { brands = [] } = this.props;
    return [...new Set([...brands].map((item) => item.service_name))].map(
      (name) => ({
        label:
          name === 'default'
            ? I18n.t('admin.benchmarkColumns.defaultService')
            : name,
        value: name
      })
    );
  }

  getData() {
    const { wines = [], brands = [] } = this.props;
    const { selectedService, activePill } = this.state;
    return activePill === 'brands'
      ? brands.filter(
          (item) =>
            selectedService && item.service_name === selectedService.value
        )
      : wines.filter(
          (item) =>
            selectedService && item.service.name === selectedService.value
        );
  }

  render() {
    const { selectedService, activePill } = this.state;
    const { wines = [], brands = [], isBranded } = this.props;
    const serviceOptionsWine = this.formatOptions(wines);
    const serviceOptionsBrand = this.formatBrandOptions(brands);
    const data = this.getData();
    return (
      <WineCompetitorsContainer>
        <Card>
          <CardHeader
            title={I18n.t('admin.benchmark')}
            icon="espace"
            iconContainer
            iconPosition="left"
            textTransform="normal"
            alignItems="center"
            styles={`.cardHeaderRight{width:100%;margin-left:0}`}
            rightComponents={
              <div className="rightHeaderContainer ignored-export">
                <div className="pillsContainer">
                  {isBranded && (
                    <Pills
                      options={[
                        { label: I18n.t('winesMaj'), value: 'wine' },
                        { label: I18n.t('brandsMaj'), value: 'brands' }
                      ].map((item) => ({
                        ...item,
                        active: activePill === item.value
                      }))}
                      onChange={({ value }) =>
                        this.setState({
                          activePill: value,
                          selectedService: {
                            label: I18n.t('restaurants&caves.subTitle.wine'),
                            value: I18n.t('restaurants&caves.subTitle.wine')
                          }
                        })
                      }
                    />
                  )}
                </div>
                <Select
                  dropdownProps={{ styles: `margin-left:-25px` }}
                  placeholder="Service"
                  value={selectedService}
                  onChange={(selectedOption) =>
                    this.setState({ selectedService: selectedOption })
                  }
                  minWidth="250px"
                  options={
                    activePill === 'wine'
                      ? serviceOptionsWine
                      : serviceOptionsBrand
                  }
                />
              </div>
            }
          />

          {activePill === 'wine' ? (
            <React.Fragment>
              <div className="wineCompetitorsHeaderContainer">
                <ListHeader
                  columns={[
                    {
                      name: I18n.t('admin.benchmarkColumns.wines'),
                      length: '33%'
                    },
                    {
                      name: I18n.t('admin.benchmarkColumns.benchmark'),
                      length: '67%'
                    }
                  ]}
                />
                <div className="wineCompetitorsListContainer">
                  {data.length > 0 &&
                    data.map((item, indexSet) => (
                      <RowContainer
                        length={item.rivals.length || 1}
                        key={indexSet}
                      >
                        <div className="wineNameContainer">
                          <p className="wineItem">{item.wine.name}</p>
                        </div>
                        <div className="rowsContainer">
                          {item.rivals.map((competitor, index) => (
                            <ListRow
                              dark={(index + indexSet) % 2 === 0}
                              key={`rowRival-${index}`}
                            >
                              <div className="competitorItem">
                                {competitor.wine.name}
                              </div>
                            </ListRow>
                          ))}
                        </div>
                      </RowContainer>
                    ))}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="wineCompetitorsHeaderContainer">
                <ListHeader
                  columns={[
                    {
                      name: I18n.t('admin.benchmarkColumns.brands'),
                      length: '33%'
                    },
                    {
                      name: I18n.t('admin.benchmarkColumns.benchmark'),
                      length: '67%'
                    }
                  ]}
                />
                <div className="wineCompetitorsListContainer">
                  {data.length > 0 &&
                    data.map((item, indexSet) => (
                      <RowContainer
                        length={Object.keys(item.rivals).length || 1}
                        key={indexSet}
                      >
                        <div className="brandNameContainer">
                          <p className="brandItem">{get(item, 'brand_name')}</p>
                          <div className="brandWineContainer">
                            {get(item, 'wines', []).map((item, index) => (
                              <p key={index} className="brandWineItem">
                                {item}
                              </p>
                            ))}
                          </div>
                        </div>
                        <div className="rowsContainerBrand">
                          {Object.keys(item.rivals).map((competitor, index) => (
                            <ListRow
                              dark={(index + indexSet) % 2 === 0}
                              key={`rowRival-${index}`}
                            >
                              <div className="competitorItem">{competitor}</div>
                              <div className="competitorWineContainer">
                                <p className="competitorWineItem">
                                  {get(item, `rivals[${competitor}]`, []).join(
                                    '- '
                                  )}
                                </p>
                              </div>
                            </ListRow>
                          ))}
                        </div>
                      </RowContainer>
                    ))}
                </div>
              </div>
            </React.Fragment>
          )}
        </Card>
      </WineCompetitorsContainer>
    );
  }
}

export default WineCompetitors;
